import { defineStore } from 'pinia';

/**
 * Стек вкладных переходов внутри приложения.
 * Используется для кнопки "назад": если есть запись в стеке — идём туда,
 * иначе (диплинк без истории) — на главную с кредами.
 */
export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        stack: [],
        isBackNavigation: false,
    }),
    actions: {
        pushRoute(route) {
            if (!route?.name) return;
            this.stack.push({
                name: route.name,
                query: { ...route.query },
                params: { ...route.params },
                fullPath: route.fullPath,
            });
        },
        popRoute() {
            return this.stack.pop();
        },
        setBackNavigation(value) {
            this.isBackNavigation = value;
        },
        clear() {
            this.stack = [];
        },
    },
});
